import React from 'react';
import './Popup.css'; // Import the CSS file

function LeaveConfirmationPopup({ showPopup, onClose }) {

    const handleRefresh = () => {
        window.location.reload();
    };
    if (!showPopup) {
        return null; // Don't render if showPopup is false
    }

    const crossButtonStyle = {
        position: 'relative',
        bottom: '20px',
        left: '118px'
    };

    return (
        <div>
            <div className="dark-background">
                <div className="popup-window">
                    <button onClick={onClose} className="text cross-button" style={crossButtonStyle}>&#x2715;</button>
                    <div style={{ position: "relative", top: -10 }}>
                        <p>Are you sure you want to leave?</p>
                    </div>
                    <button onClick={handleRefresh} className="text font-button">Yes</button>
                </div>
            </div>
        </div>
    );
}

export default LeaveConfirmationPopup;